import * as RioBravo_Components from '@on2-dev/rio-bravo-resources/components';
import * as RioBravo_Metas from '@on2-dev/rio-bravo-resources/metas';

export const packages = {
  "RioBravo": {
    components: RioBravo_Components,
    metas: RioBravo_Metas
  }
};
